// Helm zone — market, competitors, roadmap, captain
import type { MarketSize, Competitor, RoadmapItem, CaptainDashboard } from './types'
import type { RequestHelper } from './client'

export function helmMethods(r: RequestHelper) {
  return {
    // Captain Dashboard & Progress
    captain: {
      dashboard: (projectId: string) => r.get<CaptainDashboard>(`/hub/projects/${projectId}/captain`),
      updateProgress: (projectId: string, data: { moduleKey: string; stepKey: string; status: string; data?: Record<string, unknown> }) =>
        r.post<{ success: boolean }>(`/hub/projects/${projectId}/captain/progress`, data),
      getProblem: (projectId: string) => r.get<{ definition: unknown; history: unknown[] }>(`/hub/projects/${projectId}/captain/problem`),
      saveProblem: (projectId: string, data: Record<string, unknown>) =>
        r.post<{ id: string; version: number }>(`/hub/projects/${projectId}/captain/problem`, data),
    },

    // Market Size
    market: {
      get: (projectId: string) => r.get<{ market_size: MarketSize }>(`/hub/projects/${projectId}/market-size`),
      update: (projectId: string, data: Partial<MarketSize>) => r.put<{ market_size: MarketSize }>(`/hub/projects/${projectId}/market-size`, data),
    },

    // Competitors
    competitors: {
      list: (projectId: string) => r.get<{ competitors: Competitor[] }>(`/hub/projects/${projectId}/competitors`),
      get: (id: string) => r.get<{ competitor: Competitor }>(`/hub/competitors/${id}`),
      create: (projectId: string, data: Partial<Competitor>) => r.post<{ competitor: Competitor }>(`/hub/projects/${projectId}/competitors`, data),
      update: (id: string, data: Partial<Competitor>) => r.put<{ competitor: Competitor }>(`/hub/competitors/${id}`, data),
      delete: (id: string) => r.del<void>(`/hub/competitors/${id}`),
    },

    // Roadmap / Kanban
    roadmap: {
      list: (projectId: string) => r.get<{ items: RoadmapItem[] }>(`/hub/projects/${projectId}/captain/roadmap`),
      update: (projectId: string, itemId: string, data: Partial<RoadmapItem>) => r.patch<{ item: RoadmapItem }>(`/hub/projects/${projectId}/captain/roadmap/${itemId}`, data),
    },
  }
}
